// @flow
import store from 'app/common/redux/store/singleton';
import type { Pin } from 'app/packages/pinterest-flow-types/pin';
import { showReportContent } from 'app/common/redux/actions/reportContent';
import { isProductPin, isPromotedPin, isVideoPin } from 'app/common/lib/util/PinUtils';

type ArgsType = {|
  pin: Pin,
  viewParameter: ?$Values<PCONST.thrift.ViewParameterType>,
  viewType: ?$Values<PCONST.thrift.ViewType>,
|};

const dispatchReportPin = ({ pin, viewParameter, viewType }: ArgsType): (() => void) => {
  const { id, videos } = pin;
  const isProduct = isProductPin(pin);
  const isPromoted = isPromotedPin(pin);
  const isVideo = isVideoPin(videos);

  let videoDuration;
  if (isVideo && videos) {
    const { video_list } = videos;
    const videoTypes = Object.keys(video_list);
    const video = video_list[videoTypes[0]];
    videoDuration = video && video.duration;
  }

  return () => {
    store.instance.dispatch(
      showReportContent({
        id,
        isProduct,
        isPromoted,
        videoDuration,
        viewParameter,
        viewType,
        type: 'pin',
      }),
    );
  };
};

export default dispatchReportPin;
